import React from "react"
import parse from "html-react-parser"
import styled from "styled-components"
import CheckBox from "components/checkbox"

const HTMLContainer = styled.div`
  text-align: justify;
  padding: 50px;
  min-height: 700px;

  a,
  input,
  textarea,
  button,
  select {
    outline: none;
  }
  a:hover,
  h1:focus,
  h2:focus,
  h3:focus,
  h4:focus,
  h5:focus,
  h6:focus {
    text-decoration: none;
  }
  a:focus,
  input:focus,
  textarea:focus,
  button:focus,
  select:focus {
    outline: none !important;
    text-decoration: none;
  }
  input,
  textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
  }
  a {
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  img {
    max-width: 100%;
    width: auto;
    height: auto;
    vertical-align: middle;
    border: 0;
  }

  p {
    font-size: 14px;
    color: #666;
    line-height: 1.7em;
  }
  label {
    font-weight: 400;
  }

  h1 {
    font-size: 50px;
    line-height: 1.5em;
    color: #666;
  }

  textarea {
    width: 100%;
    height: 100px;
    font-size: 14px;
    color: #666;
    padding: 10px 14px;
    resize: none;
    line-height: 1.5em;
    border: 1px solid #d4d4d4;
  }

  blockquote {
    font-weight: 700;
    border-left: 3px solid #428bca;
    margin: 0 1rem;
  }
  blockquote p {
    font-style: italic;
    font-size: 14px;
  }
  blockquote cite {
    font-size: 13px;
    color: #428bca;
  }
  blockquote cite:before {
    content: "- ";
  }
  blockquote cite:after {
    content: " -";
  }
`

const HTMLSection = ({ coursewareDetails, onMarkComplete = false }) => {
  return (
    <>
      <div className="checkbox-container">
        <CheckBox
          text="Mark as Complete"
          value={coursewareDetails.completed}
          checked={coursewareDetails.completed}
          id={`chk-complete-${coursewareDetails.id}`}
          tooltip="You are required to Mark this as Completed to complete your progress"
          onClick={() => (onMarkComplete ? onMarkComplete() : false)}
        />
        <p>
          You are required to Mark this as Completed to complete your progress
        </p>
      </div>
      <div className="courseware-details">
        <h2 className="courseware-title">{`${coursewareDetails.name}`}</h2>
        {coursewareDetails.description ? (
          <p className="courseware-description">
            {coursewareDetails.description}
          </p>
        ) : (
          ""
        )}
      </div>
      <HTMLContainer>{parse(coursewareDetails?.content || "")}</HTMLContainer>
    </>
  )
}

export default HTMLSection
